import { useParams, Link } from "react-router-dom";
import { TABLETTES } from "../../data/tablettes";
import useCartStore from "../../utils/cartStore";
import { useState } from "react";

const TabletDetails = () => {
  const { id } = useParams();
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);

  const tablet = TABLETTES.find((t) => t.id === id);

  if (!tablet) {
    return <p className="section-padding">Produit introuvable</p>;
  }

  const handleAdd = () => {
    addToCart(
      {
        id: tablet.id,
        name: tablet.name,
        price: tablet.price,
        image: tablet.image,
        category: tablet.category,
      },
      quantity
    );
  };

  return (
    <div className="section-padding container-custom max-w-6xl mx-auto">
      <Link
        to="/categories/tablettes"
        className="inline-flex items-center text-gray-600 hover:text-primary mb-8"
      >
        ← Retour aux tablettes
      </Link>

      <div className="grid lg:grid-cols-2 gap-16">
        <div className="rounded-3xl overflow-hidden shadow-lg">
          <img
            src={tablet.image}
            alt={tablet.name}
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <p className="text-sm text-gray-500 mb-2">{tablet.category}</p>
          <h1 className="text-4xl font-bold mb-6">{tablet.name}</h1>

          <p className="text-gray-700 mb-8">{tablet.description}</p>

          <p className="text-2xl font-bold text-primary mb-6">
            {tablet.price} €
          </p>

          <div className="flex items-center gap-4 mb-8">
            <span className="font-medium">Quantité :</span>

            <div className="flex items-center border rounded-full">
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="px-4 py-2"
              >
                −
              </button>

              <span className="px-4 font-semibold">{quantity}</span>

              <button
                onClick={() => setQuantity(quantity + 1)}
                className="px-4 py-2"
              >
                +
              </button>
            </div>
          </div>

          <button onClick={handleAdd} className="btn-primary">
            Ajouter au panier
          </button>
        </div>
      </div>
    </div>
  );
};

export default TabletDetails;